export default __webpack_public_path__ + "static/media/n2.fda321a7.jpeg";